import React from "react";
import {withStyles,Typography,Card,CardActions,CardContent} from "@material-ui/core";
import {CustomInput,Button,CountryDropDownSelect,CustomSelect,CustomSwitch,LoadingSpinner,ErrorNotification} from "../../components"
import validate from '../../actions/validateWrapper'
import { withFirebase} from 'react-redux-firebase'



class RegisterPage extends React.Component{

    state={
        email:"",
        emailError:"",
        password:"",
        passwordError:"",
        confirmPassword:"",
        confirmPasswordError:"",
        country:"",
        countryError:"",
        acceptTCs:false,
        acceptError:"",
        isLoading:false,
        error:null
    }

    constructor(props){
        super(props)
        this.register = this.register.bind(this)

    }

    onCountrySelect = (country) => {
        this.setState({ country: country});
    }

    register(event){
        event.preventDefault();
        const {email,password,confirmPassword,country,acceptTCs} = this.state
        const {firebase,route} =this.props

        const emailError = validate('email', this.state.email)
        const passwordError = validate('password', this.state.password)
        const confirmPasswordError = validate('password', this.state.confirmPassword)
        const countryError = validate('country', this.state.country)

        console.log("acceptTCs:",this.state.acceptTCs)


        const acceptError = validate('allowTCs', this.state.acceptTCs)

        console.log("acceptError:",acceptError)

        this.setState({
            emailError: emailError,
            passwordError: passwordError,
            confirmPasswordError: confirmPasswordError,
            countryError: countryError,
            acceptError: acceptError
          })

        if(!emailError && !passwordError && !confirmPasswordError && !countryError && !acceptError){
        this.setState({isLoading:true,error:null})
        firebase.createUser({
            email:email,
            password:password,
            signIn:true
        },{
            username:email
        }).then(()=>{
            firebase.updateProfile({
                isDashboardUser:true,
                country:country
            })
            this.setState({isLoading:false})
            route.history.replace("/")

        }).catch((error)=>{
            console.error(error);
            this.setState({error:error.message,isLoading:false})
        })
    }
    }



    render(){
        const { classes} = this.props;

        const {isLoading,error} = this.state

        return(
            <div className={classes.content}>
                <Card className={classes.loginCard}>
                    <form onSubmit={this.register}>
                    <Typography variant="title" color="inherit">
                        Register
                    </Typography>

                    <CardContent>
                        <Typography variant="subheading" color="inherit">
                            Complete the fields below to create your account
                        </Typography>

                        <CustomInput
                            labelText="Email"

                            inputProps={
                                {
                                    autoFocus:true,
                                    type:"email",
                                    autoComplete:'email',
                                    onChange: (event)=>{this.setState({email:event.target.value})},
                                    onBlur:() => {
                                    this.setState({
                                    emailError: validate('email', this.state.email)
                                    })
                                }
                                }
                            }
                            formControlProps={{
                                fullWidth: true
                            }}
                            error={this.state.emailError}
                        />
                        <CustomInput
                            labelText="Password"

                            inputProps={{
                                type:"password",
                                onChange: (event)=>{this.setState({password:event.target.value})},
                                onBlur:() => {
                                    this.setState({
                                    passwordError: validate('password', this.state.password)
                                    })
                                }
                            }
                            }
                            formControlProps={{
                                fullWidth: true
                            }}
                            error={this.state.passwordError}
                        />
                        <CustomInput
                            labelText="Confirm Password"
                            inputProps={
                                {
                                    type:"password",
                                    onChange: (event)=>{this.setState({confirmPassword:event.target.value})},
                                    onBlur:() => {
                                    this.setState({
                                    confirmPasswordError: validate('password', this.state.confirmPassword)
                                    })
                                }
                                }
                            }
                            formControlProps={{
                                fullWidth: true
                            }}
                            error={this.state.confirmPasswordError}
                        />
                        <CountryDropDownSelect
                            onChange={this.onCountrySelect}
                            labelText="Country"
                            formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                        type:"select",
                        onBlur:() => {
                        this.setState({
                          countryError: validate('country', this.state.country)
                          })
                       }
                      }}
                        error={this.state.countryError}
                        />

                        <CustomSwitch
                            onChange={(value)=>{this.setState({acceptTCs:value})}}
                            labelText={"I accept the iSpani Terms and Conditions"}
                            error={this.state.acceptError}
                            />


                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        {!isLoading? <Button type="submit" color="primary">
                                Create
                            </Button>:
                            <LoadingSpinner/>
                        }
                    </CardActions>

                    </form>

                </Card>
                {error&&
                    <ErrorNotification message={error} />
                }
            </div>
        )
    }
}
const styles = {
    content:{
        display:"flex",
        paddingTop:200,
        maxWidth:400,
        margin:"auto",
        flexGrow:0.9,
        justifyContent:"center",
        textAlign:"center",
        padding:20
    },
    cardActions:{
        justifyContent:"flex-end"
    },
    loginCard:{
        paddingTop:20
    }

};

export default withFirebase(withStyles(styles)(RegisterPage));


// WEBPACK FOOTER //
// ./src/views/Register/Register.jsx